export default "__VITE_ASSET__BMHTvFAO__"